module.exports = __webpack_public_path__ + "static/media/salesforcegraphic.900f18bc.svg";